import { useQuery } from '@tanstack/react-query';
import { getProcessingRuns } from '../services/AnalyticReportsService';
export default function useProcessingRuns(filters, enabled, page = 1, perPage = 10, technicianIds = [], buildingIds = [], sortBy = null, sortDirection = undefined) {
    return useQuery(['processingRuns', filters.values.dateRange, page, perPage, technicianIds, buildingIds, sortBy, sortDirection], () => getProcessingRuns(filters, page, perPage, technicianIds, buildingIds, sortBy, sortDirection), {
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        enabled,
        keepPreviousData: true
    });
}
